import React from 'react';
import { FC } from 'react';

export const IntroSu23: FC = () => {
    return (
        <body>
            <div>
                <div> 
                    <iframe title="Slide" src="https://docs.google.com/presentation/d/e/2PACX-1vSQ4psNmmhQEpsRYJi4LYxs8_rspAXZl9oMIUwAt1QuPOEsgHfpJhmRBEWEGWIrdTWAFBv8HC_onrzp/embed?start=false&loop=false&delayms=3000"
                    width="1200" height="675"></iframe>
                </div>
                <form>
                    <label>Notes</label>
                    <textarea>
                    </textarea>
                </form>
            </div>
        </body>
    )
}